module.exports = "//static.hsappstatic.net/LoginUI/static-1.16060/img/chatspot-icon.png"